$(document).ready(function() {
    // Open specific tab or product on page load
    (function() {

        //Trigger products in scope of current tab
        $('button[data-bs-toggle="tab"]', '#productTab').on('shown.bs.tab', function (event) {
            let $elem = $($(event.target).attr('data-bs-target'));
            $elem.find('[data-bs-toggle="modal"]').each(function(idx, ele){
                $($(ele).attr('data-bs-target')).find('[name="data\[Order\]\[slug\]"]').trigger('change');
            });
        });

        let hash = window.location.hash;

        if (!hash) {
            $('#directory-tab').tab('show');
            return;
        }

        let map = {
                '#directory': '#directory-tab',
                '#dropship': '#dropship-tab',
                '#educate': '#educate-tab',
                '#insights': '#insights-tab'
            },
            $tab = $(map[hash]);

        if ($tab.length === 0) {
            return;
        }

        $tab.tab('show');
    })();

    window.ProductPricing.initDropshipPricing('#dropship-tab-pane');
    window.ProductPricing.initClassicPricing('#directory-tab-pane');
    window.ProductPricing.initInsightsV2Pricing('#insights-tab-pane');
});
